var map = {
	"./board1.jpeg": 8309,
	"./board2.jpeg": 5317,
	"./board3.jpeg": 5633,
	"./boardsAll.jpeg": 8167,
	"./boardsLandscape.jpeg": 8243,
	"./coastlines1.jpg": 8555,
	"./coastlines10.jpg": 8752,
	"./coastlines11.jpg": 8179,
	"./coastlines2.jpg": 7731,
	"./coastlines3.jpg": 4501,
	"./coastlines4.jpg": 4489,
	"./coastlines5.jpg": 4691,
	"./coastlines6.jpg": 4174,
	"./coastlines7.jpg": 9808,
	"./coastlines8.jpg": 1582,
	"./coastlines9.jpg": 4827,
	"./coastlinesLandscape.jpg": 3934,
	"./epoxy1.jpg": 7105,
	"./epoxy10.jpg": 1119,
	"./epoxy11.jpg": 364,
	"./epoxy12.jpg": 4292,
	"./epoxy2.jpg": 8663,
	"./epoxy3.jpg": 6270,
	"./epoxy4.jpg": 6883,
	"./epoxy5.jpg": 56,
	"./epoxy6.jpg": 2961,
	"./epoxy7.jpg": 35,
	"./epoxy8.jpg": 4279,
	"./epoxy9.jpg": 6990,
	"./galapagos1.jpg": 5472,
	"./galapagos10.JPG": 3547,
	"./galapagos11.JPG": 5168,
	"./galapagos12.JPG": 5275,
	"./galapagos13.jpg": 7429,
	"./galapagos14.jpg": 3260,
	"./galapagos15.jpg": 7570,
	"./galapagos2.jpg": 3489,
	"./galapagos3.jpg": 5837,
	"./galapagos4.jpg": 4335,
	"./galapagos5.jpg": 6467,
	"./galapagos6.jpg": 7986,
	"./galapagos7.jpg": 1510,
	"./galapagos8.jpg": 6451,
	"./galapagos9.jpg": 8643,
	"./nook1.jpeg": 2036,
	"./nook2.jpeg": 3040,
	"./nook3.jpeg": 7054,
	"./squirrels1.jpeg": 3363,
	"./squirrels10.jpeg": 7808,
	"./squirrels11.jpg": 5546,
	"./squirrels12.jpeg": 4418,
	"./squirrels13.jpeg": 6722,
	"./squirrels14.jpg": 6527,
	"./squirrels15.jpeg": 745,
	"./squirrels16.jpeg": 687,
	"./squirrels17.jpeg": 1224,
	"./squirrels2.jpeg": 5120,
	"./squirrels3.jpeg": 3633,
	"./squirrels4.jpeg": 7398,
	"./squirrels5.jpeg": 5550,
	"./squirrels6.jpeg": 7062,
	"./squirrels7.jpeg": 4595,
	"./squirrels8.jpeg": 8013,
	"./squirrels9.jpeg": 6991,
	"./squirrelsLandscape.jpeg": 5805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8260;